"use strict";
const _ = require('lodash');
const { getTranslation } = require('../translate');
const literToAppropriateUnit = require('../article/volume');
const getPrettyPrintVolume = articleInInventory => {
    if (articleInInventory.volume < 1) {
        return `${articleInInventory.volume * 1000}ml`;
    }
    return `${articleInInventory.volume}l`;
};
const getPrettyPrintWeight = articleInInventory => {
    if (articleInInventory.weight >= 1000) {
        return `${articleInInventory.weight / 1000}kg`;
    }
    return `${articleInInventory.weight}g`;
};
function getViewModel(articleInInventory) {
    if (!articleInInventory)
        return {};
    const result = { ...articleInInventory };
    const getDisplayOrigin = () => {
        if (!result.origin)
            return '';
        return result.origin
            .split('|')
            .map(x => _.capitalize(x))
            .join(' > ');
    };
    const getDisplayContainer = () => {
        const containerLocalizedName = getTranslation('article.containers', result.container);
        if (result.orderUnit === 'weight') {
            return '';
        }
        const displayWeight = result.weight ? `${result.weight}g` : '';
        const displaySize = result.volume > 0
            ? literToAppropriateUnit(result.volume).replace(' ', '')
            : displayWeight;
        return result.container === 'Other'
            ? containerLocalizedName
            : `${containerLocalizedName} ${displaySize}`.trim();
    };
    const getPrettyPrintAlcoholPercentage = () => {
        if (result.alcoholPercentage) {
            return `${result.alcoholPercentage}%`;
        }
        return '';
    };
    return {
        ...result,
        brandName: _.get(articleInInventory, 'brandName') ||
            _.get(articleInInventory, 'brand.name', ''), // when article is from oms
        displayOrigin: getDisplayOrigin(),
        displayContainer: getDisplayContainer(),
        displayAlcoholPercentage: getPrettyPrintAlcoholPercentage(),
    };
}
module.exports = { getViewModel, getPrettyPrintVolume, getPrettyPrintWeight };
